'use client';
import { cx } from '@linaria/core';
import { useEffect, useState } from 'react';

import { Container } from './styles';

export type AnimatedNumberProps = {
	value: number;
	duration?: { delta: number; duration: number }[];
	className?: string;
	animationType?: 'increase' | 'decrease' | 'both';
};

export const AnimatedNumber = ({
	value,
	duration = [{ delta: 0, duration: 500 }],
	animationType = 'both',
	className,
}: AnimatedNumberProps) => {
	const [displayValue, setDisplayValue] = useState(value);

	const sortedDuration = duration.sort((a, b) => b.delta - a.delta);

	useEffect(() => {
		let start = 0;
		const initialValue = displayValue;
		const difference = value - initialValue;
		const delta = Math.abs(difference);

		if (difference === 0) {
			return;
		}
		if (
			(animationType === 'increase' && difference < 0) ||
			(animationType === 'decrease' && difference > 0)
		) {
			setDisplayValue(value);
		} else {
			const currentDuration = sortedDuration.find((dur) => dur.delta < delta);

			const step = (timestamp: number) => {
				if (!start) {
					start = timestamp;
				}
				const progress = Math.min(
					(timestamp - start) / (currentDuration?.duration || 500),
					1
				);
				setDisplayValue(initialValue + difference * progress);
				if (progress < 1) {
					requestAnimationFrame(step);
				}
			};

			requestAnimationFrame(step);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [value, duration]);

	const roundValue = Math.round(displayValue);
	return (
		<Container width={roundValue.toString().length} className={cx(className)}>
			{roundValue}
		</Container>
	);
};
